import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import TreeSliderInputField from './TreeSliderInputField';
import { convertFeetToMetric, convertMetricToFeet } from '../../util';
import { selectTreeState } from 'store/slices/TreeSlice/selector';
import { updateTree } from 'store/slices/TreeSlice';
import { TreeFieldItem } from './styles';

type Props = {
	isActive: boolean;
	onActivate: () => void;
	disabled?: boolean;
};

const MIN_DIAMETER = 0;
const SLIDER_MAX_DIAMETER = 13.1;
const INPUT_MAX_DIAMETER = 13.1;
const STEP = 1;

export default function TreeTrunkDiameterField({ isActive, onActivate, disabled }: Props) {
	const dispatch = useDispatch();
	const { selectedTreeId, selectedTree } = useSelector(selectTreeState);
	const { groundMetersPerPixel } = useSelector((state: RootState) => state.roofData.data);

	if (!selectedTreeId || !selectedTree) return null;

	const metersPerPixel = groundMetersPerPixel || 1;
	const toFeet = (pixels: number) => convertMetricToFeet(pixels * metersPerPixel, 'm', 1);
	const toPixels = (feet: number) => convertFeetToMetric(feet, 'm', 6) / metersPerPixel;

	const value = toFeet((selectedTree.trunkRadius ?? 0) * 2);

	const updateValue = (next: number) => {
		const normalized = Number.isFinite(next) ? Math.max(MIN_DIAMETER, Math.min(INPUT_MAX_DIAMETER, next)) : MIN_DIAMETER;
		const nextTrunkDiameter = toPixels(normalized);
		dispatch(updateTree({
			id: selectedTreeId,
			tree:{
				trunkRadius: nextTrunkDiameter/2
			}
		}));
	};

	return (
		<TreeFieldItem>
			<TreeSliderInputField
				id="tree-trunk-diameter"
				label="Trunk Diameter"
				value={value}
				min={MIN_DIAMETER}
				max={INPUT_MAX_DIAMETER}
				sliderMax={SLIDER_MAX_DIAMETER}
				step={STEP}
				unit="ft"
				isActive={isActive}
				onActivate={onActivate}
				onInputChange={updateValue}
				showSlider={true}
				disabled={disabled}
			/>
		</TreeFieldItem>
	);
}
